import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Turn a stored cover_url (either absolute http(s) or "/api/covers/...") into
// a fully-qualified URL suitable for <img src>.
export const resolveCover = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const fetchBooks = async (q = "", category = "All", tag = "") => {
  const params = {};
  if (q) params.q = q;
  if (category && category !== "All") params.category = category;
  if (tag) params.tag = tag;
  const { data } = await api.get("/books", { params });
  return data;
};

export const fetchBook = async (id) => {
  const { data } = await api.get(`/books/${id}`);
  return data;
};

export const fetchCategories = async () => {
  const { data } = await api.get("/categories");
  return data.categories || ["All"];
};

export const fetchCategoriesManage = async () => {
  const { data } = await api.get("/categories/manage");
  return data;
};

export const createCategory = async (name) => {
  const { data } = await api.post("/categories", { name });
  return data;
};

export const updateCategory = async (id, name) => {
  const { data } = await api.patch(`/categories/${id}`, { name });
  return data;
};

export const deleteCategory = async (id) => {
  const { data } = await api.delete(`/categories/${id}`);
  return data;
};

export const fetchTags = async () => {
  const { data } = await api.get("/tags");
  return data.tags || [];
};

export const purchaseBook = async (id) => {
  const { data } = await api.post(`/books/${id}/purchase`);
  return data;
};

export const createBook = async (formData) => {
  const { data } = await api.post(`/books`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const updateBook = async (id, formData) => {
  const { data } = await api.patch(`/books/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const deleteBook = async (id) => {
  const { data } = await api.delete(`/books/${id}`);
  return data;
};

export const fetchReviews = async (bookId) => {
  const { data } = await api.get(`/books/${bookId}/reviews`);
  return data;
};

export const fetchAllReviews = async () => {
  const { data } = await api.get(`/reviews`);
  return data;
};

export const createReview = async (bookId, payload) => {
  const { data } = await api.post(`/books/${bookId}/reviews`, payload);
  return data;
};

export const updateReview = async (id, payload) => {
  const { data } = await api.patch(`/reviews/${id}`, payload);
  return data;
};

export const deleteReview = async (id) => {
  const { data } = await api.delete(`/reviews/${id}`);
  return data;
};

export const downloadUrl = (id) => `${API}/books/${id}/download`;
